export const systemActionTypes = {
  HYDRATE: 'hydrate',
  SOCKET_STATUS_SET: 'socketStatus/set',
} as const;
